<template>
  <div>
    <nav class="sidebar-right--tabs">
      <div :class="{ active: sidebarActiveTab === 'notification' }" @click="changeTab('notification')">
        {{ $t("common.notifications") }}
      </div>
      <div :class="{ active: sidebarActiveTab === 'task' }" @click="changeTab('task')">
        {{ $t("task.plural") }}
      </div>
      <div :class="{ active: sidebarActiveTab === 'question' }" @click="sidebarActiveTab = 'question'">
        {{ $t("question-set.my") }}
      </div>
    </nav>

    <div class="sidebar-right--tab-content">
      <div class="sidebar-right--wrapper" :class="{ active: sidebarActiveTab === 'notification' }">
        <div v-if="notificationPagination">
          <div class="line" v-if="notificationPagination.docs.length > 0"></div>
          <div class="sidebar-right--item" v-for="item in notificationPagination.docs" :key="item._id">
            <div class="d-flex">
              <div :class="['icon', getIconColorClass(item.type)]"><i class="iconoir-bell-notification"></i></div>
              <div>
                <div class="text">{{ item.title | translate }}</div>
                <div class="d-flex align-items-center" style="gap: 0.38rem;">
                  <div class="date">{{ item.at | date(true) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <template>
              <div class="d-flex justify-content-center my-3">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="notificationRequest.options.page"
                    :total-rows="notificationPagination.totalDocs"
                    :per-page="notificationPagination.limit"
                    limit="5"
                    size="sm"
                  ></b-pagination>
                </ul>
              </div>
            </template>
          </div>
        </div>

        <empty v-if="!notificationLoading && (!notificationPagination || notificationPagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("notification.empty") }}
          </h5>
        </empty>

        <content-loading v-if="notificationLoading" />
      </div>

      <div class="p-3" :class="{ active: sidebarActiveTab === 'task' }">
        <div v-if="taskPagination">
          <div class="search--input-container" style="margin: 1rem auto 2rem auto; width: 20.375rem;">
            <i class="search--icon iconoir-search"></i>
            <input class="search--input" v-model="nameFilter" type="text" :placeholder="$t('common.search')" />
          </div>
          <div>
            <div v-for="task in taskPagination.docs" :key="task._id">
              <kanban-card :task="task" />
            </div>
            <div class="d-flex justify-content-center">
              <template>
                <div class="d-flex justify-content-center my-3">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="taskRequest.options.page" :total-rows="taskPagination.totalDocs" :per-page="taskPagination.limit" limit="10" size="sm"></b-pagination>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>

        <empty v-if="!taskLoading && (!taskPagination || taskPagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("task.empty") }}
          </h5>
        </empty>
        <content-loading v-if="taskLoading" />
      </div>

      <div class="p-3" :class="{ active: sidebarActiveTab === 'question' }">
        <!-- TODO sorular implemente edildiğinde güncellenecek-->
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KanbanCard from "@cc/task/kanban-card";

export default {
  components: { KanbanCard },
  data() {
    return {
      sidebarActiveTab: "notification",
      nameFilter: undefined,

      notificationRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      taskRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  watch: {
    notificationRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.paginateNotification();
      },
    },
    taskRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateMyTasks());
      },
    },
    questionRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.paginateNotification();
      },
    },
    showTaskDetailModal: {
      handler() {
        this.paginateMyTasks();
      },
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.taskRequest.query = { ...this.taskRequest.query, [localizedField]: { value: n } };
      } else {
        this.taskRequest.query[localizedField] = null;
        delete this.taskRequest.query[localizedField];
      }
    },
  },
  computed: {
    notificationPagination() {
      return this.$store.getters["organizationNotification/pagination"];
    },
    taskPagination() {
      return this.$store.getters["task/myTasksPagination"];
    },
    questionPagination() {
      return this.$store.getters["question/questionPagination"];
    },
    selectedWorkspace() {
      return this.$store.getters["organization/selected"];
    },
    notificationLoading() {
      return this.$store.getters[`organizationNotification/isLoading`];
    },
    taskLoading() {
      return this.$store.getters[`task/isLoading`];
    },
    showTaskDetailModal() {
      return this.$store.getters[`task/showTaskDetailModal`];
    },
  },
  methods: {
    changeTab(tab) {
      this.sidebarActiveTab = tab;
    },
    paginateNotification() {
      if (this.selectedWorkspace) {
        this.$store.dispatch("organizationNotification/paginate", this.notificationRequest);
      }
    },
    paginateQuestion() {},
    async paginateMyTasks() {
      try {
        await this.$store.dispatch("task/fetchCurrentUserAssignedTask", {
          ...this.taskRequest,
          query: {
            ...this.taskRequest.query,
            organization: { value: this.currentOrganization?._id, isObject: true },
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    getIconColorClass(type) {
      switch (type) {
        case "ERROR":
          return "text-danger";
        case "INFO":
          return "text-primary";
        case "NEWS":
          return "text-info";
        case "SUCCESS":
          return "text-success";
        case "WARNING":
          return "text-warning";
        default:
          return "text-dark";
      }
    },
  },
};
</script>

<style scoped></style>
